import { Calendar } from '@fullcalendar/core';
import interactionPlugin from '@fullcalendar/interaction';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import gcalPlugin from '@fullcalendar/google-calendar';
import jaLocale from '@fullcalendar/core/locales/ja';
import './main.css';

import moment from 'moment';
import Swal from 'sweetalert2';

moment.locale("ja");

document.addEventListener('DOMContentLoaded', function() {
    var calendarEl = document.getElementById('calendar');
    var fcView = 'dayGridMonth';
    var fcHeight;

    //モバイルモード(#mobileを付ける)場合はリスト表示、大文字
    if(location.hash == '#mobile') {
	calendarEl.style.fontSize = '32px';
	fcView = 'listMonth';
	fcHeight = window.innerHeight - 100;
    }
    
    var calendar = new Calendar(calendarEl, {

	plugins: [ gcalPlugin,interactionPlugin,dayGridPlugin,listPlugin ],

	headerToolbar: {
            left: 'prev,next today',
            center: 'title',
            right: 'dayGridMonth,dayGridWeek,listMonth'
	},
	initialView: fcView,
	locale: jaLocale,
	businessHours: true,
	displayEventTime: true, // don't show the time column in list view
	height: fcHeight,

	googleCalendarApiKey: 'AIzaSyA2_O3tbQdA99rjG4SbujGD_EPYQRAVe7g',
	eventSources: [
	    {
		//世田谷フィル練習計画
		googleCalendarId: 'b9kua5134chcrlnrb7quo1n8hr8rd509@import.calendar.google.com'
	    },
	    {
		//日本の休日
		googleCalendarId: 'japanese__ja@holiday.calendar.google.com',
		rendering: 'background'
	    }
	],
	
	// イベントクリック時の詳細ポップアップ
	eventClick: function(arg) {
	    
            arg.jsEvent.preventDefault() // don't navigate in main tab
            let title = arg.event.title;
            let loc = arg.event.extendedProps.location || "";
            let desc = arg.event.extendedProps.description || "";
            let date = moment(arg.event.start).format("MM月DD日（ddd曜日）");
            let time = (arg.event.allDay)? "終日": moment(arg.event.start).format("HH:mm") + "～" + moment(arg.event.end).format("HH:mm");
	    
            Swal.fire({
		html:
		`<div id="xDtlDlgCt" class="Mz3isd"> 
		    <div class="kMp0We"> 
		    <div class="OLw7vb"><span class="DPvwYc">info</span></div> 
		    <div id="xDetDlgTitle">${title}</div> 
		    </div> 
		    <div class="kMp0We"> 
		    <div class="OLw7vb"><span class="DPvwYc">access_time</span></div> 
		    <div id="xDetDlgWhen"><div>${date}<span class="amqcKf">:</span><span>${time}</span></div></div>
		    </div> 
		    <div class="kMp0We"> 
		    <div class="OLw7vb"><span class="DPvwYc">place</span></div> 
		    <div id="xDetDlgLoc">${loc}</div> 
		    </div>
		    <div class="kMp0We">
		    <div class="OLw7vb"><span class="DPvwYc">article</span></div>
		    <div class="F4hRyg" id="xDetDlgDesc">${desc}</div>
		    </div>
		    </div>`
            });
	    
	},
	
	loading: function(bool) {
            document.getElementById('loading').style.display =
		bool ? 'block' : 'none';
	}
	
    });
    
    calendar.render();
});

